import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import type { QuizParticipantStatusDto, QuizStatisticsFilter } from "../../types/quiz-statistics";

export const useGetQuizParticipants = (
  examId: string | null,
  filter: QuizStatisticsFilter,
  enabled = true
) => {
  const axios = useAxios();

  return useQuery<QuizParticipantStatusDto[]>({
    queryKey: ["quizParticipants", examId, filter],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filter.startDate) params.append("startDate", filter.startDate);
      if (filter.endDate) params.append("endDate", filter.endDate);
      const { data } = await axios.get<QuizParticipantStatusDto[]>(
        `/api/challenges/QuizParticipants/${examId}?${params.toString()}`
      );
      return data;
    },
    enabled: !!examId && enabled,
    refetchInterval: 15_000,
  });
};
